/**
 * Featured Product – Interactive variant selection
 * Click variant options to update selection, image, and price.
 */

(function () {
  'use strict';

  function initFeaturedProduct() {
    var sections = document.querySelectorAll('.featured-product');

    sections.forEach(function (section) {
      var variantsJson = section.querySelector('[data-fp-variants]');
      var imageMapJson = section.querySelector('[data-fp-image-map]');
      var productImg = section.querySelector('[data-fp-product-img]');
      var productImgGif = section.querySelector('[data-fp-product-gif]');
      var atcBtn = section.querySelector('[data-fp-atc]');
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var priceEl = section.querySelector('.featured-product__price');
      var optionItems = section.querySelectorAll('[data-fp-option]');
      var variants = [];
      var productImages = [];

      if (variantsJson) {
        try { variants = JSON.parse(variantsJson.textContent); } catch (err) { /* noop */ }
      }
      if (imageMapJson) {
        try { productImages = JSON.parse(imageMapJson.textContent); } catch (err) { /* noop */ }
      }

      /* Helper: find best matching image for a color name */
      function findImageForColor(color) {
        var c = color.toLowerCase();
        var best = null;
        var bestScore = 0;
        for (var i = 0; i < productImages.length; i++) {
          var fn = productImages[i].filename;
          var score = 0;
          /* Exact substring match */
          if (fn.indexOf(c) !== -1) { score = 100; }
          else if (c.indexOf(fn.replace(/[^a-z]/g, '')) !== -1) { score = 80; }
          else {
            /* Fuzzy: count matching chars from start */
            var words = fn.replace(/[^a-z]/g, ' ').split(/\s+/);
            for (var w = 0; w < words.length; w++) {
              var word = words[w];
              var matched = 0;
              for (var ch = 0; ch < Math.min(c.length, word.length); ch++) {
                if (c[ch] === word[ch]) matched++;
                else break;
              }
              if (matched >= 4 && matched > score) score = matched;
            }
          }
          if (score > bestScore) {
            bestScore = score;
            best = [productImages[i].url, productImages[i + 1] ? productImages[i + 1].url : null];
          }
        }
        return bestScore >= 4 ? best : null;
      }

      /* Detect which option index is Color */
      var colorOptionIndex = -1;
      var optionGroups = section.querySelectorAll('.featured-product__option-group');
      optionGroups.forEach(function (group) {
        var label = group.querySelector('.featured-product__option-label');
        if (label) {
          var txt = label.textContent.toLowerCase().trim().replace(':', '');
          if (txt === 'color' || txt === 'colour' || txt === 'colors') {
            colorOptionIndex = parseInt(group.getAttribute('data-option-group-index'), 10);
          }
        }
      });

      if (!variants.length || !optionItems.length) return;

      var optionGroups = section.querySelectorAll('.featured-product__option-group');

      function getSelectedOptionsFromUI() {
        var selected = [];
        optionGroups.forEach(function (group) {
          var active = group.querySelector('.featured-product__option-item.is-active');
          if (!active) return;
          var idx = parseInt(active.getAttribute('data-option-index'), 10);
          selected[idx] = String(active.getAttribute('data-option-value') || '').trim();
        });
        return selected;
      }

      function normalizeOptionValue(value) {
        return String(value == null ? '' : value).trim().toLowerCase();
      }

      function findMatchedVariant(selected) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = true;
          for (var j = 0; j < v.options.length; j++) {
            if (normalizeOptionValue(selected[j]) !== normalizeOptionValue(v.options[j])) {
              match = false;
              break;
            }
          }
          if (match) return v;
        }
        return null;
      }

      var initialSelected = getSelectedOptionsFromUI();
      var initialVariant = findMatchedVariant(initialSelected);
      if (initialVariant && atcBtn) {
        atcBtn.setAttribute('data-variant-id', initialVariant.id);
      }

      /* Click handler for each option */
      optionItems.forEach(function (item) {
        item.addEventListener('click', function (e) {
          /* On tablet, if clicking the already-active item, let it bubble to toggle dropdown */
          if (window.innerWidth <= 960 && item.classList.contains('is-active')) return;
          /* On tablet, stop propagation so group toggle doesn't re-open after selecting */
          if (window.innerWidth <= 960) e.stopPropagation();
          var optionIndex = parseInt(item.getAttribute('data-option-index'), 10);
          var optionValue = item.getAttribute('data-option-value');

          /* Update UI – remove active from siblings, add to clicked */
          var parentList = item.closest('.featured-product__option-list');
          var siblings = parentList.querySelectorAll('.featured-product__option-item');
          siblings.forEach(function (sib) {
            sib.classList.remove('is-active');
            /* Remove arrow */
            var arrow = sib.querySelector('.featured-product__option-arrow');
            if (arrow) arrow.remove();
            /* Remove bold from value */
            var val = sib.querySelector('.featured-product__option-value');
            if (val) val.classList.remove('is-active');
          });

          item.classList.add('is-active');
          /* Add arrow */
          var arrowSpan = document.createElement('span');
          arrowSpan.className = 'featured-product__option-arrow';
          arrowSpan.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.78403 2.86102e-05H7.34403L11.648 5.69603L7.34403 11.392H4.78403L6.78403 8.75203C7.41336 7.90936 7.96269 7.20536 8.43203 6.64003H2.55108e-05V4.73603H8.41603C7.78669 3.9467 7.24269 3.24803 6.78403 2.64003L4.78403 2.86102e-05Z" fill="white"/></svg>';
          item.insertBefore(arrowSpan, item.firstChild);
          /* Bold value */
          var valueEl = item.querySelector('.featured-product__option-value');
          if (valueEl) valueEl.classList.add('is-active');

          /* Find matching variant */
          var selectedOptions = getSelectedOptionsFromUI();
          var matchedVariant = findMatchedVariant(selectedOptions);

          if (matchedVariant) {
            /* Update variant ID on ATC button */
            if (atcBtn) {
              atcBtn.setAttribute('data-variant-id', matchedVariant.id);
            }

            /* Update product image: try variant image first, then fuzzy color→image match */
            var newImgUrl = matchedVariant.featured_image;
            var newIngGifUrl = null;
            if (!newImgUrl && colorOptionIndex >= 0 && selectedOptions[colorOptionIndex]) {
              const newImgUrls = findImageForColor(selectedOptions[colorOptionIndex]);
              newImgUrl = newImgUrls ? newImgUrls[0] : null;
              newIngGifUrl = newImgUrls ? newImgUrls[1] : null;
              console.log('Found image for color: ' + selectedOptions[colorOptionIndex] + ', newImgUrl: ' + newImgUrl + ', newIngGifUrl: ' + newIngGifUrl);
            }
            if (newImgUrl && productImg) {
              productImg.style.opacity = '0';
              if (productImgGif) productImgGif.style.opacity = '0';
              productImgGif.src = newIngGifUrl || '';
              setTimeout(function () {
                var onMainImageReady = function () {
                  productImg.removeEventListener('load', onMainImageReady);
                  productImg.removeEventListener('error', onMainImageReady);
                  productImg.style.opacity = '';
                  if (productImgGif) productImgGif.style.opacity = '';
                };

                productImg.addEventListener('load', onMainImageReady);
                productImg.addEventListener('error', onMainImageReady);
                productImg.src = newImgUrl;
                if (productImg.complete && productImg.naturalWidth > 0) {
                  onMainImageReady();
                }
                if (productImgGif) productImgGif.src = newIngGifUrl;
              }, 300);
            }

            /* Update price */
            if (priceEl) {
              var formatted = '$' + (matchedVariant.price / 100).toFixed(2) + ' AUD';
              priceEl.textContent = formatted;
            }
          }

          /* Close dropdown after selecting on tablet */
          var parentGroup = item.closest('.featured-product__option-group');
          if (parentGroup) parentGroup.classList.remove('is-open');
        });
      });

      /* Tablet dropdown toggle – click pill to open/close */
      var allGroups = section.querySelectorAll('.featured-product__option-group');
      allGroups.forEach(function (group) {
        group.addEventListener('click', function (e) {
          /* Only toggle on tablet */
          if (window.innerWidth > 960) return;
          /* If dropdown is already open and clicking a non-active item, let item handler run */
          var clickedItem = e.target.closest('.featured-product__option-item');
          if (group.classList.contains('is-open') && clickedItem && !clickedItem.classList.contains('is-active')) return;
          /* Close other open groups */
          allGroups.forEach(function (g) {
            if (g !== group) g.classList.remove('is-open');
          });
          group.classList.toggle('is-open');
          e.stopPropagation();
        });
      });

      /* Close dropdowns when clicking outside */
      document.addEventListener('click', function () {
        allGroups.forEach(function (g) { g.classList.remove('is-open'); });
      });

      /* ATC button – AJAX add to cart */
      if (atcBtn) {
        atcBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var selectedOptions = getSelectedOptionsFromUI();
          var matchedVariant = findMatchedVariant(selectedOptions);
          var variantId = matchedVariant ? matchedVariant.id : parseInt(atcBtn.getAttribute('data-variant-id'), 10);
          if (!variantId) return;

          atcBtn.disabled = true;
          atcBtn.classList.add('isloading');

          var config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          var formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', '1');

          if (cart && typeof cart.getSectionsToRender === 'function') {
            formData.append(
              'sections',
              cart.getSectionsToRender().map(function (sectionToRender) {
                return sectionToRender.id;
              })
            );
            formData.append('sections_url', window.location.pathname);
          }

          config.body = formData;

          fetch(routes.cart_add_url, config)
            .then(function (res) {
              return res.json();
            })
            .then(function (response) {
              if (response.status) {
                throw new Error(response.description || response.message || 'Add to cart failed');
              }

              if (!cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'featured-product',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              }

              if (cart.tagName === 'CART-DRAWER') {
                cart.renderContents(response, {
                  source: 'featured-product',
                  forceOpenOnHomepage: true,
                });
              } else {
                cart.renderContents(response);
              }

              setTimeout(function () {
                atcBtn.disabled = false;
                atcBtn.classList.remove('isloading');
              }, 1500);
            })
            .catch(function () {
              atcBtn.disabled = false;
              atcBtn.classList.remove('isloading');
            });
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeaturedProduct);
  } else {
    initFeaturedProduct();
  }
})();
